import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import { setAuthen } from '../libs/todoSlice';
import { useDispatch } from 'react-redux';
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const RedirectOne = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [cookie, setCookie, removeCookie] = useCookies(['account', 'new_user', 'oauth_callback', 'cookie_consent_accepting'])
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);  

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const sharedToken = query.get("sharedtoken");
        const bizID = query.get("bizid");

        if (sharedToken && bizID) {
            getURL(sharedToken, bizID);
        } else {
            navigate('/');
        }
    }, [location.search]);

    const getURL = async (sharedToken, bizID) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/v5/login/shared-token`,
                {
                    shared_token: sharedToken,
                    is_remember: true,
                    business_id: bizID,
                }
            );

            const data = response.data.data;
            if (data && data.prefix && data.account_id) {
                const account = await getProfile(bizID);
                localStorage.setItem("account", JSON.stringify(account));

                setCookie('new_user', {
                    changed_password: data.changed_password,
                }, { path: '/' });

                dispatch(setAuthen({ authen: true }));
                const redirectURL = `/${data.prefix}/home`;
                navigate(redirectURL);
            } else {
                throw new Error("Invalid response data");
            }
        } catch (err) {
            setError(err.message);  
            console.log(err)
            navigate('/');
        } finally {
            setLoading(false);
        }
    };

    const getProfile = async (bizID) => {
        try {
            const profile = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v5/profile/user/${bizID}`);
            if (profile && profile.data.data) {
                return profile.data.data;
            }
            throw new Error("Profile not found");
        } catch (err) {
            setError(err.message);  
            throw err;  
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                textAlign: "center",
            }}
        >
            {loading ? (
                <CircularProgress />
            ) : (
                error && <p style={{ color: "red" }}>{error}</p>
            )}
        </Box>
    );
};

export default RedirectOne;
